<template>
	<div class="task-box">
		<div class="task-title">T3：职业发展策略</div>
		<div class="task_new">
			<h2>需求策略<span>（以下内容自动获取，可自行进行调整。）</span></h2>
			<!--  -->
			<div class="task_ninput">
				<span>我所在的 </span>
				<input v-model="policy_trade" type="text" class="task_n" />
				<span> 行业。</span>
			</div>
			<!--  -->
			<div class="task_ninput">
				<span>其中分为 </span>
				<input v-model="policy_track1" type="text" class="task_n" />
				<span> 、</span>
				<input v-model="policy_track2" type="text" class="task_n" />
				<span> 、</span>
				<input v-model="policy_track3" type="text" class="task_n" />
				<span> 几个赛道。</span>
			</div>
			<!--  -->
			<div class="task_ninput">
				<span>近2年最值得关注的是 </span>
				<input v-model="policy_trend1" type="text" class="task_n" />
				<span> 、</span>
				<input v-model="policy_trend2" type="text" class="task_n" />
				<span> 、</span>
				<input v-model="policy_trend3" type="text" class="task_n" />
				<span> 趋势。</span>
			</div>
			<!--  -->
			<div class="task_ninput">
				<span>当前职位的职业发展路径，有 </span>
				<input v-model="policy_targetjob1" type="text" class="task_n" />
				<span> 、</span>
				<input v-model="policy_targetjob2" type="text" class="task_n" />
				<span> 、</span>
				<input v-model="policy_targetjob3" type="text" class="task_n" />
				<span> 三个方向。</span>
			</div>
		</div>
		<div class="task_new">
			<h2>稀缺策略<span>（下方输入框最多输入18个汉字）</span></h2>
			<div class="task_ninput">
				<span>我现在更倾向于 </span>
				<input type="text" class="task_ns" v-model="jobpath" />
				<span> 路径。</span>
			</div>
			<div class="task_ninput line">
				<span>所以我要在工作里、培训里做 </span>
				<input type="text" class="task_ns" v-model="jobchance1" />
				<span>  、</span>
				<input type="text" class="task_ns" v-model="jobchance2" />
				<span>  、</span>
				<input type="text" class="task_ns" v-model="jobchance3" />
				<span>  能力的储备。</span>
			</div>
		</div>
		<div class="btn-box">
			<div @click="submitData" :class="[isAllowCommit ? 'active' : '', 'submit-task']">提交</div>
		</div>
	</div>
</template>
<script>
	import { getresearchdata, updateresearchdata } from "@/api/course"
	import { getStorage, setStorage } from "@/utils/tools"
	import { shareCon } from "@/utils/wxconfig";
	export default {
		data(){
			return {
				isAllowCommit: false,
				//
				policy_trade: "",
				//
				policy_track1: "",
				policy_track2: "",
				policy_track3: "",
				//
				policy_trend1: "",
				policy_trend2: "",
				policy_trend3: "",
				//
				policy_targetjob1: "",
				policy_targetjob2: "",
				policy_targetjob3: "",
				//
				jobpath: "",
				//
				jobchance1: "",
				jobchance2: "",
				jobchance3: ""
			}
		},
		methods: {
			submitData(){
				if(!this.isAllowCommit){
					return
				}
				// 提交
				this.commitData();
			},
			commitData(){
				let q = this.$route.query;
				updateresearchdata({
					cid: q.cid,
					cpid: q.pid,
					cptid: q.id,
					type: "taskthree",
					iscreate: 1,
					policy_trade: this.policy_trade,
					jobpath: this.jobpath,
					policy_track: `${this.policy_track1}/${this.policy_track2}/${this.policy_track3}`,
					policy_trend: `${this.policy_trend1}/${this.policy_trend2}/${this.policy_trend3}`,
					policy_targetjob: `${this.policy_targetjob1}/${this.policy_targetjob2}/${this.policy_targetjob3}`,
					jobchance: `${this.jobchance1}/${this.jobchance2}/${this.jobchance3}`
				})
				.then((data) => {
					let q = this.$route.query;
					// 去报告页面
					this.$router.push({
						path: "/project_report",
						query: {
							cid: q.cid,
							cpid: q.pid,
							type: "trademap"
						}
					});
				})
			},
			changeCommitState(){
				if(
						this.policy_trade.length &&
						//
						this.policy_track1.length &&
						this.policy_track2.length &&
						this.policy_track3.length &&
						//
						this.policy_trend1.length &&
						this.policy_trend2.length &&
						this.policy_trend3.length &&
						//
						this.policy_targetjob1.length &&
						this.policy_targetjob2.length &&
						this.policy_targetjob3.length &&
						//
						this.jobpath.length &&
						//
						this.jobchance1.length &&
						this.jobchance2.length &&
						this.jobchance3.length
					){
					this.isAllowCommit = true;
				}else{
					this.isAllowCommit = false;
				}
			},
			pullData(){
				let q = this.$route.query;
				getresearchdata({
					type: "taskthree",
					cid: q.cid
				})
				.then((data) => {
					let {
						jobchance,
						jobpath,
						policy_targetjob,
						policy_track,
						policy_trade,
						policy_trend
					} = data.data;
					if(
						jobchance,
						jobpath,
						policy_targetjob,
						policy_track,
						policy_trade,
						policy_trend
						){
						// 远程数据
						this.setDataVal(true, data.data);
					}else{
						this.setDataVal(false, data.data);
					}
				})
			},
			setDataVal(bool, d){
				let path = this.$route.path;
				this.policy_trade = bool ? d.policy_trade : getStorage(path, 'policy_trade') || '';
				this.jobpath = bool ? d.jobpath : getStorage(path, 'jobpath') || '';
				//
				let dev1 = d.policy_track.split('/');
				this.policy_track1 = bool ? dev1[0] : getStorage(path, 'policy_track1') || '';
				this.policy_track2 = bool ? dev1[1] : getStorage(path, 'policy_track2') || '';
				this.policy_track3 = bool ? dev1[2] : getStorage(path, 'policy_track3') || '';
				//
				let dev2 = d.policy_trend.split('/');
				this.policy_trend1 = bool ? dev2[0] : getStorage(path, 'policy_trend1') || '';
				this.policy_trend2 = bool ? dev2[1] : getStorage(path, 'policy_trend2') || '';
				this.policy_trend3 = bool ? dev2[2] : getStorage(path, 'policy_trend3') || '';
				//
				let dev3 = d.policy_targetjob.split('/');
				this.policy_targetjob1 = bool ? dev3[0] : getStorage(path, 'policy_targetjob1') || '';
				this.policy_targetjob2 = bool ? dev3[1] : getStorage(path, 'policy_targetjob2') || '';
				this.policy_targetjob3 = bool ? dev3[2] : getStorage(path, 'policy_targetjob3') || '';
				//
				let dev4 = d.jobchance.split('/');
				this.jobchance1 = bool ? dev4[0] :  getStorage(path, 'jobchance1') || '';
				this.jobchance2 = bool ? dev4[1] :  getStorage(path, 'jobchance2') || '';
				this.jobchance3 = bool ? dev4[2] :  getStorage(path, 'jobchance3') || '';

			},
			setPageTitle(){
				let title = this.$route.query.name;
				document.title = decodeURI(title);
			}
		},
		created(){
			this.pullData();
			this.setPageTitle();
			shareCon("course",this);
		},
		watch: {
			policy_trade(curVal, oldVal){
				if(curVal.length > 20) {
		      this.policy_trade = curVal.slice(0, 20);
		      this.$toast('最多只能输入20个字符。/(ㄒoㄒ)/~~');
		    }else{
		    	setStorage(this.$route.path, 'policy_trade', curVal);
		    	this.changeCommitState();
		    }
			},
			policy_track1(curVal, oldVal){
				if(curVal.length > 20) {
		      this.policy_track1 = curVal.slice(0, 20);
		      this.$toast('最多只能输入20个字符。/(ㄒoㄒ)/~~');
		    }else{
		    	setStorage(this.$route.path, 'policy_track1', curVal);
		    	this.changeCommitState();
		    }
			},
			policy_track2(curVal, oldVal){
				if(curVal.length > 20) {
		      this.policy_track2 = curVal.slice(0, 20);
		      this.$toast('最多只能输入20个字符。/(ㄒoㄒ)/~~');
		    }else{
		    	setStorage(this.$route.path, 'policy_track2', curVal);
		    	this.changeCommitState();
		    }
			},
			policy_track3(curVal, oldVal){
				if(curVal.length > 20) {
		      this.policy_track3 = curVal.slice(0, 20);
		      this.$toast('最多只能输入20个字符。/(ㄒoㄒ)/~~');
		    }else{
		    	setStorage(this.$route.path, 'policy_track3', curVal);
		    	this.changeCommitState();
		    }
			},
			policy_trend1(curVal, oldVal){
				if(curVal.length > 20) {
		      this.policy_trend1 = curVal.slice(0, 20);
		      this.$toast('最多只能输入20个字符。/(ㄒoㄒ)/~~');
		    }else{
		    	setStorage(this.$route.path, 'policy_trend1', curVal);
		    	this.changeCommitState();
		    }
			},
			policy_trend2(curVal, oldVal){
				if(curVal.length > 20) {
		      this.policy_trend2 = curVal.slice(0, 20);
		      this.$toast('最多只能输入20个字符。/(ㄒoㄒ)/~~');
		    }else{
		    	setStorage(this.$route.path, 'policy_trend2', curVal);
		    	this.changeCommitState();
		    }
			},
			policy_trend3(curVal, oldVal){
				if(curVal.length > 20) {
		      this.policy_trend3 = curVal.slice(0, 20);
		      this.$toast('最多只能输入20个字符。/(ㄒoㄒ)/~~');
		    }else{
		    	setStorage(this.$route.path, 'policy_trend3', curVal);
		    	this.changeCommitState();
		    }
			},
			policy_targetjob1(curVal, oldVal){
				if(curVal.length > 20) {
		      this.policy_targetjob1 = curVal.slice(0, 20);
		      this.$toast('最多只能输入20个字符。/(ㄒoㄒ)/~~');
		    }else{
		    	setStorage(this.$route.path, 'policy_targetjob1', curVal);
		    	this.changeCommitState();
		    }
			},
			policy_targetjob2(curVal, oldVal){
				if(curVal.length > 20) {
		      this.policy_targetjob2 = curVal.slice(0, 20);
		      this.$toast('最多只能输入20个字符。/(ㄒoㄒ)/~~');
		    }else{
		    	setStorage(this.$route.path, 'policy_targetjob2', curVal);
		    	this.changeCommitState();
		    }
			},
			policy_targetjob3(curVal, oldVal){
				if(curVal.length > 20) {
		      this.policy_targetjob3 = curVal.slice(0, 20);
		      this.$toast('最多只能输入20个字符。/(ㄒoㄒ)/~~');
		    }else{
		    	setStorage(this.$route.path, 'policy_targetjob3', curVal);
		    	this.changeCommitState();
		    }
			},
			jobpath(curVal, oldVal){
				if(curVal.length > 18) {
		      this.jobpath = curVal.slice(0, 18);
		      this.$toast('最多只能输入18个字符。/(ㄒoㄒ)/~~');
		    }else{
		    	setStorage(this.$route.path, 'jobpath', curVal);
		    	this.changeCommitState();
		    }
			},
			jobchance1(curVal, oldVal){
				if(curVal.length > 18) {
		      this.jobchance1 = curVal.slice(0, 18);
		      this.$toast('最多只能输入18个字符。/(ㄒoㄒ)/~~');
		    }else{
		    	setStorage(this.$route.path, 'jobchance1', curVal);
		    	this.changeCommitState();
		    }
			},
			jobchance2(curVal, oldVal){
				if(curVal.length > 18) {
		      this.jobchance2 = curVal.slice(0, 18);
		      this.$toast('最多只能输入18个字符。/(ㄒoㄒ)/~~');
		    }else{
		    	setStorage(this.$route.path, 'jobchance2', curVal);
		    	this.changeCommitState();
		    }
			},
			jobchance3(curVal, oldVal){
				if(curVal.length > 18) {
		      this.jobchance3 = curVal.slice(0, 18);
		      this.$toast('最多只能输入18个字符。/(ㄒoㄒ)/~~');
		    }else{
		    	setStorage(this.$route.path, 'jobchance3', curVal);
		    	this.changeCommitState();
		    }
			}
		}
	}
</script>
<style lang="scss" scoped>
	@import "@s/taskStyle.scss";
	.task_new{
    margin-top: changeRem(0.8)+px;
    width: 100%;
    text-align: left;
    h2{
    	font-size: changeRem(0.64)+px;
    	color: #333;
    	font-weight: normal;
	    margin: 0;
	    span{
	    	color: #666;
    		font-size: changeRem(0.48)+px;
    		vertical-align: bottom;
	    }
    }
	}

  .line{
    line-height: changeRem(1.8)+px;
    margin-top: changeRem(0.2)+px;
  }
  .btn-box{
  	margin-top: changeRem(1.6)+px;
    margin-bottom: changeRem(1.6)+px;
  }
</style>